import React from 'react';
import { FormBuilder } from 'commons-ui';
import { useStyletron } from 'styletron-react';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from './formConfig';
import useAthenaUpdateDetails from './useAthenaUpdateDetails';

const AthenaUpdateDetails: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader, data } = useAthenaUpdateDetails();
	const [css] = useStyletron();
	return (
		<div>
			<h3
				className={css({
					textAlign: 'center',
					marginTop: '20px',
					marginBottom: '20px'
				})}>
				Edit Athena CRUD Request
			</h3>
			<FormBuilder
				data={data}
				mode='edit'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Update',
					discardLabel: 'Back'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default AthenaUpdateDetails;
